import React from 'react';

import {
  Menu,
  MenuItem,
  IconButton,
  Stack,
  ArrowUpwardIcon,
  ArrowDownwardIcon,
  SortIcon,
} from '@gogame/components';

export default ({ sortedColumnList, onChange, orderDirectionAsc, orderBy }) => {
  return (
    <Menu anchor={<IconButton icon={<SortIcon />} tooltip={'Sort by'} />}>
      {sortedColumnList.map(({ id, name }) => {
        const selected = orderBy === id;

        return (
          <MenuItem key={id} selected={selected} onClick={onChange(id)}>
            <Stack
              width={'100%'}
              direction={'row'}
              alignItems={'center'}
              spacing={1}
            >
              <Stack width={24} direction={'row'} alignItems={'center'}>
                {selected ? (
                  orderDirectionAsc ? (
                    <ArrowUpwardIcon color={'action'} />
                  ) : (
                    <ArrowDownwardIcon color={'action'} />
                  )
                ) : null}
              </Stack>
              <span>{name}</span>
            </Stack>
          </MenuItem>
        );
      })}
    </Menu>
  );
};
